
module Meevo.Components.Orientation {

    export class MeevoGlobalMobileOrientation {
        private window: angular.IWindowService;
        restrict = "E";
        templateUrl = 'app/components/orientation/globalOrientationTemplate.html';
        scope = {
            mainState: "="
        };

        constructor($window: ng.IWindowService) {
            this.window = $window;
        }
        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.isSupported = true;
            scope.isLandscape;
            scope.messageKey = 'MESSAGE_MEEVO_NOT_SUPPORTED_ON_CUR_DEVICE_AND_LAYOUT';
            var userAgentString = angular.element('html').attr('class').split(" ");
            scope.check = () => {
                //Called twice - once for a smooth experience, second time for slower devices that arent ready the first time it is called
                window.setTimeout(function () { scope.$apply(scope.setSupported()); }, 250)
                window.setTimeout(function () { scope.$apply(scope.setSupported()); }, 1000)
            }
            scope.setSupported = () => {
                if ((/Mobile/i.test(navigator.userAgent) && !/ipad/i.test(navigator.userAgent)) || /android/i.test(navigator.userAgent)) {
                    scope.isLandscape = (window.innerHeight <= window.innerWidth) ? true : false;
                    if (scope.isLandscape) {
                        scope.wasLandscape = true;
                        scope.setViewportScale();
                        if (/android/i.test(navigator.userAgent) && window.innerHeight >= 350) {
                            return scope.isSupported = true;
                        } else if (scope.mainState.name === 'reports' || scope.mainState.name === 'appointmentBook' || scope.mainState.name === 'schedules') {
                            return scope.isSupported = true;
                        } else {
                            return scope.isSupported = false;
                        }

                    } else if (!scope.isLandscape) {
                        // relayout needed to prevent Safari whitespace issue (Bug 16285) when rotating back to portrait
                        if (scope.wasLandscape) {
                            scope.setViewportScale();
                        }
                        scope.wasLandscape = false;
                        return scope.isSupported = true;
                    }
                }
            }
            scope.check();

            scope.$watch('mainState.name', function () {
                scope.check();
            });

            angular.element(window).bind('orientationchange', function () {
                scope.check();
            });

            // viewport scale reduced to make purple header clickable in Safari mobile landscape (Bug 16286)
            scope.setViewportScale = () => {
                const viewportMetaTag = document.querySelector('meta[name="viewport"]');
                let viewportString: string = viewportMetaTag.getAttribute("content");
                viewportString = scope.isLandscape ? viewportString.replace("initial-scale=1", "initial-scale=.95") : viewportString.replace("initial-scale=.95", "initial-scale=1");
                viewportMetaTag.setAttribute("content", viewportString);
            }
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($window) => {
                return new MeevoGlobalMobileOrientation($window);
            };
            directive.$inject = ["$window"];
            return directive;
        }
    }



    angular.module("meevo")
        .directive("meevoGlobalMobileOrientation", MeevoGlobalMobileOrientation.factory());
}
